import React from 'react'
import Form from "./Form/Form"
import Letreiro from './Letreiro/Letreiro'

function Contato() {
  return (
    <>
        <Letreiro/>
        <Form/>
    </>
  )
}

export default Contato